import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Signup from './components/Signup';
import ForgotPassword from './components/ForgotPassword';
import ResetPassword from './components/ResetPassword';
import AssistantSelector from './components/AssistantSelector';
import General from './components/General';
import Users from './components/Users';
import Prompts from './components/Prompts';
import AnalysisPrompt from './components/AnalysisPrompt';
import TextToSpeech from './components/TextToSpeech';
import LLMSettings from './components/LLMSettings';
import SpeechToText from './components/SpeechToText';
import CreateCall from './components/CreateCall';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { assistantService } from './utils/api';
import theme from './theme';

// Protected route component
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) {
    return <Navigate to="/login" />;
  }
  return children;
};

// Assistant protected route component
const AssistantProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const selectedAssistant = assistantService.getSelectedAssistant();
  
  if (!token) {
    return <Navigate to="/login" />;
  }
  
  if (!selectedAssistant) {
    return <Navigate to="/assistants" />;
  }
  
  return children;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/assistants" element={
            <ProtectedRoute>
              <AssistantSelector />
            </ProtectedRoute>
          } />
          <Route path="/assistant/:assistantId/general" element={
            <AssistantProtectedRoute>
              <General />
            </AssistantProtectedRoute>
          } />
          <Route path="/assistant/:assistantId/users" element={
            <AssistantProtectedRoute>
              <Users />
            </AssistantProtectedRoute>
          } />
          <Route path="/assistant/:assistantId/prompts" element={
            <AssistantProtectedRoute>
              <Prompts />
            </AssistantProtectedRoute>
          } />
          <Route path="/assistant/:assistantId/analysis-prompt" element={
            <AssistantProtectedRoute>
              <AnalysisPrompt />
            </AssistantProtectedRoute>
          } />
          <Route path="/assistant/:assistantId/tts" element={
            <AssistantProtectedRoute>
              <TextToSpeech />
            </AssistantProtectedRoute>
          } />
          <Route path="/assistant/:assistantId/llm" element={
            <AssistantProtectedRoute>
              <LLMSettings />
            </AssistantProtectedRoute>
          } />
          <Route path="/assistant/:assistantId/stt" element={
            <AssistantProtectedRoute>
              <SpeechToText />
            </AssistantProtectedRoute>
          } />
          <Route path="/assistant/:assistantId/create-call" element={
            <AssistantProtectedRoute>
              <CreateCall />
            </AssistantProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
      <ToastContainer position="top-right" autoClose={5000} />
    </ThemeProvider>
  );
}

export default App;
